export const ADD_NEW_NOTE_TO_LIST = 'ADD_NEW_NOTE_TO_LIST';
export const RECEIVE_NOTES_LIST = 'RECEIVE_NOTE_LIST';
export const UPDATE_NOTES_LIST = 'UPDATE_NOTES_LIST';
export const DELETE_NOTE_FROM_LIST = 'DELETE_NOTE_FROM_LIST';
